module.exports = __webpack_public_path__ + "static/media/DigiPen_Singapore_WEB_RED.f425fce4.jpg";